<template>
  <div style="display: inline-block; position: relative;">

    <!-- Botón toggle -->
    <v-btn icon x-small :color="diffColor" @click="open = !open" v-show="!open">
      <v-icon>{{ open ? 'mdi-information' : 'mdi-information-outline' }}</v-icon>
    </v-btn>

    <!-- Panel inline -->
    <div v-if="open" style="margin-top: 6px; border-radius: 6px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.15); min-width: 400px;max-width: 410px;">

      <!-- Header -->
      <div style="background: #524D4D; padding: 8px 12px; display: flex; align-items: center; justify-content: space-between;">
        <div style="display: flex; align-items: center; gap: 6px;">
          <v-icon small dark>mdi-calculator-variant</v-icon>
          <span style="color: white; font-size: 12px; font-weight: 600;">Detalle de cálculo — Diferencia Tabla 1 / Tabla 2</span>
        </div>
        <v-btn icon x-small dark @click="open = false">
          <v-icon x-small>mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Tabla -->
      <table style="width: 100%; border-collapse: collapse; font-size: 11px; table-layout: fixed; background: white;">
        <colgroup>
          <col style="width: 150px;">
          <col style="width: 28px;">
          <col v-for="q in localQuotas" :key="'col-'+q.uid">
        </colgroup>

        <!-- HEADER -->
        <thead>
          <tr :style="{ backgroundColor: supervisionTableColor, color: calcFontColor(supervisionTableColor) }">
            <td colspan="2" style="padding: 6px 10px; font-weight: 700; font-size: 11px; letter-spacing: 0.3px; border: 1px solid rgba(255,255,255,0.2);">
              DIFERENCIA UF
            </td>
            <td
              v-for="(quota, qi) in localQuotas"
              :key="'dh-'+quota.uid"
              style="padding: 6px 10px; font-weight: 700; font-size: 11px; text-align: center; border: 1px solid rgba(255,255,255,0.2);">
              CUOTA {{ qi + 1 }}
            </td>
          </tr>
        </thead>

        <tbody>

          <!-- Fila Tabla 1 -->
          <tr style="border-bottom: 1px solid #e8e8e8;">
            <td style="padding: 5px 10px; font-weight: 500; border: 1px solid #e0e0e0;">Tabla 1</td>
            <td style="border: 1px solid #e0e0e0;"></td>
            <td
              v-for="(q, qi) in adjustmentSummaryDynamic"
              :key="'dt1-'+q.uid"
              style="padding: 5px 10px; border: 1px solid #e0e0e0; text-align: right;">
              <div v-if="qi === 0">
                <p class="mb-0 font-weight-bold">{{ (q.t1Uf || 0) | toThousandFilter(2) }} UF</p>
                <p class="mb-0">${{ (q.t1Clp || 0) | toThousandFilter }}</p>
              </div>
            </td>
          </tr>

          <!-- Fila Tabla 2 -->
          <tr style="border-bottom: 1px solid #e8e8e8;">
            <td style="padding: 5px 10px; font-weight: 500; border: 1px solid #e0e0e0;">Tabla 2</td>
            <td style="border: 1px solid #e0e0e0;"></td>
            <td
              v-for="(q, qi) in adjustmentSummaryDynamic"
              :key="'dt2-'+q.uid"
              style="padding: 5px 10px; border: 1px solid #e0e0e0; text-align: right;">
              <div v-if="qi === 0">
                <p class="mb-0 font-weight-bold">{{ (q.t2Uf || 0) | toThousandFilter(2) }} UF</p>
                <p class="mb-0">${{ (q.t2Clp || 0) | toThousandFilter }}</p>
              </div>
            </td>
          </tr>

          <!-- Fila diferencia UF -->
          <tr>
            <td style="padding: 5px 10px; border: 1px solid #e0e0e0;" :style="{ color: diffColor }">
              <p class="mb-0 font-weight-bold">Total Diferencia</p>
              <p class="mb-0" style="font-size: 10px;">
                <span v-if="quota1DiffUf > 0">A favor empresa</span>
                <span v-else-if="quota1DiffUf < 0">A favor cliente</span>
              </p>
            </td>
            <td style="padding: 5px 4px; text-align: center; font-size: 16px; border: 1px solid #e0e0e0; border-right: none;" :style="{ color: diffColor }">→</td>
						<td
							v-for="(q) in adjustmentSummaryDynamic"
							:key="'adj-diff-'+q.uid"
							class="text-right supervision-quota-col"
							style="vertical-align: middle;">
							<div class="d-flex align-center justify-end" style="gap: 12px;">
								<div v-if="q.diffUf" :style="{ color: q.diffUf > 0 ? '#FF120B' : 'green' }">
									<p class="mb-0 font-weight-bold">
										{{ (q.diffUf || 0) | toThousandFilter(2) }} UF
									</p>
									<p class="mb-0">
										${{ (q.diffClp || 0) | toThousandFilter }}
									</p>
								</div>
								<div v-else>
									--
								</div>
							</div>
						</td>
          </tr>

          <!-- Sub-fila CLP -->
          <tr>
            <td style="border: 1px solid #e0e0e0; border-top: none; padding: 0 10px 4px;"></td>
            <td style="border: 1px solid #e0e0e0; border-top: none;"></td>
						<td
							v-for="(q,qi) in adjustmentSummaryDynamic"
							:key="'adj-verify-'+q.uid"
              style="padding: 0 10px 4px; text-align: right; border: 1px solid #e0e0e0; border-top: none;">
							<div v-if="q.diffUf">
								<p class="mb-0 font-weight-bold">
									{{ (q.diffUf || 0) | toThousandFilter(2) }} UF
								</p>
								<p class="mb-0">
									${{ (q.diffClp || 0) | toThousandFilter }}
								</p>
							</div>
							<div v-else-if="qi > 0">
								<p class="mb-0 font-weight-bold">{{ q.t2Uf | toThousandFilter(2) }} UF</p>
								<p class="mb-0">${{ q.t2Clp | toThousandFilter }}</p>
							</div>
							<div v-else>
								--
							</div>
						</td>
          </tr>

          <!-- Sub-fila nota UF -->
          <tr>
            <td style="border: 1px solid #e0e0e0; border-top: none; padding: 0 10px 5px;"></td>
            <td style="border: 1px solid #e0e0e0; border-top: none;"></td>
            <td
              v-for="(q, qi) in adjustmentSummaryDynamic"
              :key="'ddiff-note-'+q.uid"
              style="padding: 0 10px 5px; text-align: right; font-size: 9px; color: #999; border: 1px solid #e0e0e0; border-top: none;">
              <template v-if="qi === 0 && hasSentEmailsTable1">Mantiene UF Tabla 1</template>
              <template v-else-if="todayUfValue">UF AL {{ todayUfValue.date | toDate }}</template>
            </td>
          </tr>

          <!-- Fila total diferencia en pesos -->
          <tr v-if="quota1DiffUf !== 0" style="border-top: 1px solid #ddd;">
            <td colspan="3" style="padding: 4px 10px; text-align: right; font-size: 10px; color: #555; border: 1px solid #e0e0e0;">
              total diferencia en pesos patrocinio tabla 1 y tabla 2
            </td>
            <td
              v-for="q in adjustmentSummaryDynamic.filter(aq => nextSupervisionQuota && aq.uid === nextSupervisionQuota.uid)"
              :key="'dpesos-'+q.uid"
              style="padding: 4px 10px; text-align: right; border: 1px solid #e0e0e0;">
              <span class="font-weight-bold">${{ quota1DiffClp | toThousandFilter }}</span>
            </td>
          </tr>

          <!-- Fila cuota N° patrocinio -->
          <tr v-if="nextSupervisionQuota">
            <td colspan="3" style="padding: 4px 10px; text-align: right; font-size: 10px; color: #555; border: 1px solid #e0e0e0;">
              cuota {{ 'nº' + (nextQuotaIndex + 1) }} patrocinio
            </td>
            <td
              v-for="q in adjustmentSummaryDynamic.filter(aq => aq.uid === nextSupervisionQuota.uid)"
              :key="'dcuota-'+q.uid"
              style="padding: 4px 10px; text-align: right; border: 1px solid #e0e0e0;">
              <span class="font-weight-bold">${{ nextSummaryTotals.supervisionClp | toThousandFilter }}</span>
            </td>
          </tr>

        </tbody>

        <!-- Totales a pagar -->
        <tbody v-if="nextSupervisionQuota" style="border-top: 3px solid #bbb;">
          <tr>
            <td colspan="3" style="padding: 6px 10px; border: 1px solid #e0e0e0;">
              Total a pagar Cuota {{ 'nº' + (nextQuotaIndex + 1) }} patrocinio
            </td>
						<td
							v-for="(q) in adjustmentSummaryDynamic.filter(q => q.finalUf)"
							:key="'fila-totals-'+q.uid"
							class="text-center supervision-quota-col"
              style="padding: 6px 10px; text-align: right; border: 1px solid #e0e0e0;">
							<div v-if="q.finalUf">
								<p class="mb-0 font-weight-bold text-right">
									{{ q.finalUf | toThousandFilter(2) }} UF
								</p>
								<p class="mb-0 text-right">
									${{ q.finalClp | toThousandFilter }}
								</p>
							</div>
						</td>
          </tr>
        </tbody>

      </table>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SupervisionDiffDetailInline',
  props: {
    supervisionTotalsDynamic: { type: Object, required: true },
    adjustmentSummaryDynamic: { type: Array, required: true },
    localQuotas: { type: Array, required: true },
    supervisionTableColor: { type: String, default: '#524D4D' },
    nextSupervisionQuota: { type: Object, default: null },
    nextSummaryTotals: { type: Object, required: true },
    hasSentEmailsTable1: { type: Boolean, default: false },
    todayUfValue: { type: Object, default: null }
  },
  data() {
    return {
      open: false
    }
  },
  computed: {
    diffColor() {
      return this.quota1DiffUf > 0 ? '#FF120B' : 'green'
    },
    quota1DiffUf() {
      const q0 = this.adjustmentSummaryDynamic[0]
      if (!q0) return 0
      return (q0.t2Uf || 0) - (q0.t1Uf || 0)
    },
    quota1DiffClp() {
      const q0 = this.adjustmentSummaryDynamic[0]
      if (!q0) return 0
      return (q0.t2Clp || 0) - (q0.t1Clp || 0)
    },
    nextQuotaIndex() {
      if (!this.nextSupervisionQuota) return -1
      return this.localQuotas.findIndex(lq => lq.uid === this.nextSupervisionQuota.uid)
    }
  },
	watch: {
		open(newVal) {
			this.$emit('isOpen', newVal)
		}
	},
  methods: {
    calcFontColor(backgroundColor) {
      if (!backgroundColor) return '#000'
      let hex = backgroundColor.replace('#', '')
      if (hex.length === 3) hex = hex.split('').map(c => c + c).join('')
      const r = parseInt(hex.substring(0, 2), 16)
      const g = parseInt(hex.substring(2, 4), 16)
      const b = parseInt(hex.substring(4, 6), 16)
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      return brightness > 128 ? '#000' : '#fff'
    }
  }
}
</script>